import { StorageKeys } from '../sessionStorage/storageKeys';
class ShareWithApollo {
    /**
     * Inittialize service
     * @param _storage - Internal parameter for Dependency Injection [DO NOT USE] -
     * storage util - sessionStorage
     * @param _storageKeyLegacy - Internal parameter for Dependency Injection [DO NOT USE] -
     * storage key for og
     * @returns {void}
     */
    constructor(_storage = sessionStorage, _storageKeyLegacy = StorageKeys.LegacySession) {
        this.dataForLegacy = {};
        this._storage = _storage;
        this._storageKeyLegacy = _storageKeyLegacy;
        this.getDataForLegacyFromStore();
        this.removeDataForLegacyFromStore();
    }
    /**
     * Get data Apollo shared with Og app
     * @returns {DataForLegacy}
     */
    getDataForLegacy() {
        return this.dataForLegacy;
    }
    /**
     * Get data that apollo shared from storage and save it to property
     * @returns {void}
     */
    getDataForLegacyFromStore() {
        const dataForLegacy = this._storage.getItem(this._storageKeyLegacy);
        this.dataForLegacy = dataForLegacy ? JSON.parse(dataForLegacy) : {};
    }
    /**
     * Remove data we get from apollo from storage
     * @returns {void}
     */
    removeDataForLegacyFromStore() {
        this._storage.removeItem(this._storageKeyLegacy);
    }
}
export const shareWithApollo = new ShareWithApollo();
